<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">物品档案变更</div>   
     <form-list ref="modify_goods_status" :statusList="statusList"  :n="n" :configAreaFid="configAreaFid" :compensate="compensate" ></form-list> 
  </Modal>
</template>
<script type="text/ecmascript-6">
import { getGoodsUseStatus,updateGoodsStatus } from 'api/archives';
// import { getContract } from 'api/meterRecharge'
import FormList from './FormItem';
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    projectId:{
      type:String,
      default:''
    },
    configArea:{
      type:Number,
      default:null
    },
    configAreaFid:{
      type:String,
      default:''
    },
    compensate:{
      type:Number,
      default:null
    },
    goodsArchivesCode:{
      type:String,
      default:''
    },
    curStatus:{
      type:Number,
      default:null
    }
  },
  components: {
    FormList  
  },
  created() {
    getGoodsUseStatus().then( res=> {
      this.allStatus = res.data.useStatus
      this.statusList= this.allStatus.filter( item => {
        return item.value !== this.curStatus
     })
    })
  },
  data () {
    return {
      show:false,
      loading:true,
      allStatus:[],
      statusList:[],
      contractList:[]
    }
  },
 watch:{
   n(val){
     this.statusList= this.allStatus.filter( item => {
        return item.value !== this.curStatus  
     })
     
     this.show = true
   }
 },
 methods:{
   changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
  },
  save(){
    let data = {
      configArea:this.configArea,
      configAreaFid: this.configAreaFid,
      goodsArchivesCode:this.goodsArchivesCode,
      projectId:this.projectId,
    }
    let params = this.$refs['modify_goods_status'].formValidate();
    if(!params){
      this.changeLoading()
      return
    }
    let targetData = Object.assign({},data,params)
    updateGoodsStatus(targetData).then(res => {
      this.$Message.success('变更成功');
      this.changeLoading()
      this.show=false
      this.$emit('refresh')
    }).catch(()=>{
      this.changeLoading()
    })
   }
 }
}
</script>
